import { request } from '../request';

/**
 * 添加运营商
 *
 * @param params 请求参数
 * @returns 添加运营商
 */
export const fetchAddOperator = (params: {
  name: string;
  parent_id?: string;
  contact_person: string;
  contact_phone: string;
}) => {
  return request<any>({
    url: '/user/web/operator/',
    method: 'post',
    data: params
  });
};

/**
 * 更新运营商
 *
 * @param params 请求参数
 * @returns 更新运营商
 */
export const fetchUpdateOperator = (params: any) => {
  return request<any>({
    url: `/user/web/operator/${params.operator_id}/update/`,
    method: 'post',
    data: params
  });
};

/**
 * 添加商户
 *
 * @param params 请求参数
 * @returns 添加商户
 */
export const fetchAddMerchant = (params: any) => {
  return request<any>({
    url: '/user/web/merchant/',
    method: 'post',
    data: params
  });
};

/**
 * 更新商户
 *
 * @param params 请求参数
 * @returns 更新商户
 */
export const fetchUpdateMerchant = (params: any) => {
  return request<any>({
    url: `/user/web/merchant/${params.merchant_id}/update/`,
    method: 'post',
    data: params
  });
};

/**
 * 添加校区
 *
 * @param params 请求参数
 * @returns 添加校区
 */
export const fetchAddSchool = (params: any) => {
  return request<any>({
    url: '/user/web/location/',
    method: 'post',
    data: params
  });
};

/**
 * 更新校区
 *
 * @param params 请求参数
 * @returns 更新校区
 */
export const fetchUpdateSchool = (params: any) => {
  return request<any>({
    url: `/user/web/location/${params.id}/update/`,
    method: 'post',
    data: params
  });
};

/** 删除校区 */
export const fetchDelSchool = (id: string | number) => {
  return request<any>({
    url: `/user/web/location/${id}/`,
    method: 'delete'
  });
};

/**
 * 批量添加水卡
 *
 * @param params 请求参数
 * @returns 批量添加水卡
 */
export const fetchBatchAddWaterCard = (params: any) => {
  return request<any>({
    url: '/water/cardinfo/bulk-import/',
    method: 'post',
    data: params
  });
};

/**
 * 添加水卡
 *
 * @param params 请求参数
 * @returns 添加水卡
 */
export const fetchAddWaterCard = (params: any) => {
  return request<any>({
    url: '/water/cardinfo/create-card/',
    method: 'post',
    data: params
  });
};

/**
 * 更新水卡
 *
 * @param id 水卡ID
 * @param params 请求参数
 * @returns 更新水卡
 */
export const fetchUpdateWaterCard = (id: string | number, params: any) => {
  return request<any>({
    url: `/water/cardinfo/${id}/update/`,
    method: 'post',
    data: params
  });
};
/**
 * 添加饮水设备
 *
 * @param params 请求参数
 * @returns 添加饮水设备
 */
export const fetchAddWaterDevice = (params: any) => {
  return request<any>({
    url: '/device/device-water/',
    method: 'post',
    data: params
  });
};

/**
 * 获取饮水设备
 *
 * @param params 请求参数
 * @returns 获取饮水设备
 */
export const fetchGetWaterDevice = (params: any) => {
  return request<any>({
    url: '/device/device-water/',
    method: 'get',
    params
  });
};

/**
 * 更新饮水设备
 *
 * @param params 请求参数
 * @returns 更新饮水设备
 */
export const fetchUpdateWaterDevice = (params: any) => {
  return request<any>({
    url: `/device/device-water/${params.id}/update/`,
    method: 'post',
    data: params
  });
};

/**
 * 添加角色
 *
 * @param params 请求参数
 * @returns 添加角色
 */
export const fetchAddRole = (params: { code: string; name: string }) => {
  return request<any>({
    url: '/user/web/role/',
    method: 'post',
    data: params
  });
};

/**
 * 删除角色
 *
 * @param params 请求参数
 * @returns 删除角色
 */
export const fetchDelRole = (id: string | number) => {
  return request<any>({
    url: `/user/web/role/${id}/`,
    method: 'delete'
  });
};

/**
 * 添加出水口模板
 *
 * @param params 请求参数
 * @returns 添加出水口模板
 */
export const fetchAddOutletTemplate = (params: any) => {
  return request<any>({
    url: '/device/outlet-template/',
    method: 'post',
    data: params
  });
};

/**
 * 更新出水口模板
 *
 * @param params 请求参数
 * @returns 更新出水口模板
 */
export const fetchUpdateOutletTemplate = (id: string | number, params: any) => {
  return request<any>({
    url: `/device/outlet-template/${id}/update/`,
    method: 'post',
    data: params
  });
};

/**
 * 获取指定设备出水口
 *
 * @param id 设备ID
 * @returns 获取指定设备出水口
 */
export const getSpecialOutletDetail = (id: string | number) => {
  return request<any>({
    url: `/device/device-outlet-config/`,
    method: 'get',
    params: {
      device_id: id
    }
  });
};

/**
 * 更新出水口
 *
 * @param type 类型 copy为出水口管理页面的编辑
 * @param params 请求参数
 * @returns 更新出水口
 */
export const fetchUpdateOutlet = (type: 'edit' | 'add' | 'copy' | 'device', params: Record<string, any>) => {
  let url = '/device/device-outlet-config/';
  const resParams = { ...params };
  if (type === 'edit' || type === 'copy') {
    url = `/device/device-outlet-config/${params?.id}/update/`;
    Reflect.deleteProperty(resParams, 'outlet_sn');
    Reflect.deleteProperty(resParams, 'device');
  }
  return request<any>({
    url,
    method: 'post',
    data: resParams
  });
};

/**
 * 删除出水口
 *
 * @param id 出水口ID
 * @returns 删除出水口
 */
export const fetchDelOutlet = (id: string | number) => {
  return request<any>({
    url: `/device/device-outlet-config/${id}/`,
    method: 'delete'
  });
};

/**
 * 添加平台用户
 *
 * @param params 请求参数
 * @returns 添加平台用户
 */
export const fetchAddPlatformUser = (params: Record<string, any>) => {
  return request<any>({
    url: '/user/web/userinfo/create-user/',
    method: 'post',
    data: params
  });
};

/**
 * 更新平台用户
 *
 * @param id 用户ID
 * @param params 请求参数
 * @returns 更新平台用户
 */
export const fetchUpdatePlatformUser = (
  id: string | number,
  params: { name: string; phone: string; role_code: string; is_active: boolean }
) => {
  return request<any>({
    url: `/user/web/userinfo/${id}/update/`,
    method: 'post',
    data: params
  });
};

/**
 * 重置平台用户密码
 *
 * @param id 用户ID
 * @param params 请求参数
 * @returns 重置平台用户密码
 */
export const fetchUpdatePlatformUserPassword = (id: string | number, params: Record<string, any>) => {
  return request<any>({
    url: `/user/web/userinfo/${id}/reset-password/`,
    method: 'post',
    data: params
  });
};

/**
 * 添加充值活动
 *
 * @param params 请求参数
 * @returns 添加充值活动
 */
export const fetchAddRechargeActivity = (params: Record<string, any>) => {
  return request<any>({
    url: '/order/web-activity/',
    method: 'post',
    data: params
  });
};

/**
 * 更新充值活动
 *
 * @param id 活动ID
 * @param params 请求参数
 * @returns 更新充值活动
 */
export const fetchUpdateRechargeActivity = (id: string | number, params: Record<string, any>) => {
  return request<any>({
    url: `/order/web-activity/${id}/update/`,
    method: 'post',
    data: params
  });
};

/**
 * 删除充值活动
 *
 * @param id 活动ID
 * @returns 删除充值活动
 */
export const fetchDelRechargeActivity = (id: string | number) => {
  return request<any>({
    url: `/order/web-activity/${id}/`,
    method: 'delete'
  });
};

/**
 * 获取平台用户信息
 *
 * @param id 用户ID
 * @returns 获取平台用户信息
 */
export const fetchGetPlatformUserInfo = (id: string | number, params?: Record<string, any>) => {
  return request<any>({
    url: `/user/web/student/${id}/`,
    method: 'get',
    params
  });
};

/**
 * 获取转学历史
 *
 * @param id 用户ID，可选
 * @returns 获取转学历史
 */
export const fetchGetChangeSchoolHistory = (
  id?: string | number,
  params: Record<string, any> = { limit: 1000, offset: 0 }
) => {
  return request<any>({
    url: `/user/web/student/transfer-history/`,
    method: 'get',
    params: {
      user_id: id,
      ...params
    }
  });
};

/**
 * 获取信息修改历史
 *
 * @param id 用户ID
 * @returns 获取信息修改历史
 */
export const fetchGetModHistory = (id: string | number) => {
  return request<any>({
    url: `/user/web/student/${id}/update-logs/`,
    method: 'get'
  });
};

/**
 * 更新平台用户信息
 *
 * @param id 用户ID
 * @param params 请求参数
 * @returns 更新平台用户信息
 */
export const fetchUpdateMiniUserInfo = (id: string | number, params: Record<string, any>) => {
  return request<any>({
    url: `/user/web/student/${id}/update/`,
    method: 'post',
    data: params
  });
};

/**
 * 更新平台用户学校
 *
 * @param id 用户ID
 * @param params 请求参数
 * @returns 更新平台用户学校
 */
export const fetchUpdateMiniUserMerchant = (id: string | number, params: Record<string, any>) => {
  return request<any>({
    url: `/user/web/student/${id}/transfer/`,
    method: 'post',
    data: params
  });
};

/**
 * 重置平台用户密码
 *
 * @param id 用户ID
 * @param params 请求参数
 * @returns 重置平台用户密码
 */
export const fetchUpdateMiniUserPassword = (id: string | number, params: Record<string, any>) => {
  return request<any>({
    url: `/user/web/student/${id}/reset-password/`,
    method: 'post',
    data: params
  });
};

/**
 * 获取订单详情
 *
 * @param id 订单id
 * @returns
 */
export const fetchOrderDetail = (id, params?: Record<string, any>) => {
  return request<any>({
    url: `/order/web/${id}/`,
    method: 'get',
    params
  });
};

/**
 * 获取订单消费明细
 *
 * @param id 订单id
 * @returns 获取订单消费明细
 */
export const fetchOrderConsumeDetail = (id, params?: Record<string, any>) => {
  return request<any>({
    url: `/order/web-consume/`,
    method: 'get',
    params: {
      ...params,
      order_id: id
    }
  });
};

// 获取设备状态
export const getCurrentDeviceStatus = (deviceId?: string) => {
  return request<any>({
    url: deviceId ? `/device/state/${deviceId}/` : '/device/state/',
    method: 'get'
  });
};

/**
 * 提现审核
 *
 * @param params 请求参数
 * @returns 提现审核
 */
export const fetchWithdrawReview = (id: string | number, params: Record<string, any>) => {
  return request<any>({
    url: `/finance/withdraw/${id}/review/`,
    method: 'post',
    data: params
  });
};

/**
 * 提现
 *
 * @param params 请求参数
 * @returns 提现
 */
export const fetchWithdraw = (params: Record<string, any>) => {
  return request<any>({
    url: `/finance/withdraw/`,
    method: 'post',
    data: params
  });
};

/**
 * 手动结算
 *
 * @param params 请求参数
 * @returns 手动结算
 */
export const fetchSettlement = (params: Record<string, any>) => {
  return request<any>({
    url: `/finance/settlement/run-daily/`,
    method: 'post',
    data: params
  });
};

/**
 * 更新订单状态
 *
 * @param id 订单id
 * @param params 请求参数
 * @returns 更新订单状态
 */
export const fetchUpdateOrderStatus = (id: string, params: Record<string, any>) => {
  return request<any>({
    url: `/order/web/${id}/set-status/`,
    method: 'post',
    data: params
  });
};

/**
 * 创建模拟订单批次
 *
 * @param params 请求参数
 * @returns 创建结果
 */
export const fetchCreateSimulationBatch = (params: Record<string, any>) => {
  return request<any>({
    url: '/order/web-simulation-batch/',
    method: 'post',
    data: params
  });
};

/** 创建或补足商户模拟用户池 */
export const fetchEnsureSimulationUserPool = (params: Record<string, any>) => {
  return request<any>({
    url: '/order/web-simulation-batch/user-pool/',
    method: 'post',
    data: params
  });
};

/** 软删除模拟订单批次 */
export const fetchDeleteSimulationBatch = (id: string | number) => {
  return request<any>({
    url: `/order/web-simulation-batch/${id}/`,
    method: 'delete'
  });
};

/** 停用模拟订单批次 */
export const fetchDisableSimulationBatch = (id: string | number) => {
  return request<any>({
    url: `/order/web-simulation-batch/${id}/disable/`,
    method: 'post'
  });
};

/** 启用模拟订单批次 */
export const fetchEnableSimulationBatch = (id: string | number) => {
  return request<any>({
    url: `/order/web-simulation-batch/${id}/enable/`,
    method: 'post'
  });
};

/** 物理删除模拟订单批次及模拟数据 */
export const fetchHardDeleteSimulationBatch = (id: string | number) => {
  return request<any>({
    url: `/order/web-simulation-batch/${id}/hard-delete/`,
    method: 'post'
  });
};

/** 查询模拟订单批次进度 */
export const fetchSimulationBatchProgress = (id: string | number) => {
  return request<any>({
    url: `/order/web-simulation-batch/${id}/progress/`,
    method: 'get'
  });
};

/** 创建模拟订单周期配置 */
export const fetchCreateSimulationSchedule = (params: Record<string, any>) => {
  return request<any>({
    url: '/order/web-simulation-batch/schedules/',
    method: 'post',
    data: params
  });
};

/** 更新模拟订单周期配置 */
export const fetchUpdateSimulationSchedule = (id: string | number, params: Record<string, any>) => {
  return request<any>({
    url: `/order/web-simulation-batch/schedules/${id}/`,
    method: 'post',
    data: params
  });
};

/** 停用模拟订单周期配置 */
export const fetchDisableSimulationSchedule = (id: string | number) => {
  return request<any>({
    url: `/order/web-simulation-batch/schedules/${id}/`,
    method: 'delete'
  });
};

/** 立即执行模拟订单周期配置 */
export const fetchRunSimulationScheduleNow = (id: string | number, params: Record<string, any> = {}) => {
  return request<any>({
    url: `/order/web-simulation-batch/schedules/${id}/run-now/`,
    method: 'post',
    data: params
  });
};
